/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandTrackingSettings} from '../api'

export const useMutationSetBrandTrackingSettings = createReactQueryMutationHook('setBrandTrackingSettings', setBrandTrackingSettings)
